import {localStorageKey} from "@/api/config";
import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Api from "@/api";
import 'dayjs/locale/ko';
import _ from "lodash";
import PageHeader from "@/components/PageHeader.vue";
import RegisterHeader from "@/components/RegisterHeader.vue";
import PageFooter from "@/components/PageFooter.vue";
import StoragePlugin from 'vue-web-storage';
import VueDayjs from 'vue3-dayjs-plugin'
import {vfmPlugin} from "vue-final-modal";
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import ko from "element-plus/dist/locale/ko"
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import SimpleVueValidator from 'simple-vue3-validator'
import VueDaumPostcode from 'vue-daum-postcode'
import InfiniteLoading from 'v3-infinite-loading';
import DatePicker from 'vue-datepicker-next';
import 'vue-datepicker-next/locale/ko.es'
import 'vue-datepicker-next/index.css';
import moment from 'moment';
import $ from "jquery";
import 'swiper/css';
import {Visibility50Directive} from "@/utils/visibilityWatcher";
import coinBalanceReturnSyncMixin from "@/mixins/coinBalanceReturnSyncMixin";
window.$ = $
window.global = window;


let app = createApp(App);
app.mixin(coinBalanceReturnSyncMixin);
app.use(router)
app.use(vfmPlugin)
app.use(VueDaumPostcode)
app.use(StoragePlugin, {
    prefix: localStorageKey,
    drivers: ['local'],
})
app.use(VueDayjs)
app.component('page-header', PageHeader)
app.component('register-header', RegisterHeader)

app.component('date-picker', DatePicker);
app.component('page-footer', PageFooter)
app.component('infinite-loading', InfiniteLoading)
app.config.globalProperties.$_ = _;

app.config.globalProperties.$api = Api;
app.directive('visibility50', Visibility50Directive);

app.use(ElementPlus, {
    locale: ko
})
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.config.globalProperties.$moment = moment;
app.use(SimpleVueValidator);
app.use(store)
app.mount('#app')
